import { makeStyles } from "tss-react/mui"
import getContentUrl from "utils-lib/getContentUrl"
import { wmColor } from "themes-lib/wmTheme"
import Typography from "component-lib/Base/components/Typography"
import { ReactSVG } from "react-svg"

const useStyles = makeStyles()((theme, { hasGreenBackground }) => ({
  headerContainer: {
    display: `flex`,
    alignItems: `center`,
    marginBottom: `0.5rem`,
    fontSize: `1.125rem`,
    fontWeight: `bold`,
    lineHeight: `1.3755rem`,
    color: "#4f4f58",
  },
  header: {
    fontSize: `1.125rem`,
    fontWeight: `bold`,
    lineHeight: `1.3755rem`,
    color: hasGreenBackground ? theme.palette.primary.contrastText : ``,
  },
  body: {
    fontSize: `1rem`,
    lineHeight: `1.5rem`,
    color: hasGreenBackground
      ? theme.palette.primary.main
      : theme.palette.primary.darkGray,
    [theme.breakpoints.down(`sm`)]: {
      textAlign: `left !important`,
    },
  },
  icon: {
    height: 30,
    width: 40,
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    marginRight: `0.5rem`,
    "& *": {
      stroke: hasGreenBackground
        ? theme.palette.primary.contrastText
        : theme.palette.primary.main,
    },
  },
  headerTextAlignment: {
    "&&": {
      [theme.breakpoints.down(`sm`)]: {
        textAlign: `left !important`,
      },
    },
  },
}))

export const Tile = ({
  icon = ``,
  heading = ``,
  headingAlignment = `left`,
  description = ``,
  descriptionAlignment = `left`,
  hasGreenBackground,
}) => {
  const { classes } = useStyles({ hasGreenBackground })

  return (
    <div className="Tile" data-testid="Tile">
      <div className={classes.headerContainer}>
        {icon && (
          <ReactSVG
            wrapper="span"
            className={classes.icon}
            src={getContentUrl(icon)}
            aria-hidden
          />
        )}
        <Typography
          data-testid="Heading"
          variant="h5"
          className={`flex-grow-1 text-${headingAlignment} ${classes.headerTextAlignment}`}
          style={{ color: wmColor.black }}
        >
          {heading}
        </Typography>
      </div>

      <Typography
        data-testid="Description"
        variant="body2"
        className={`text-${descriptionAlignment} ${classes.body}`}
      >
        {description}
      </Typography>
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// Tile.propTypes = {
//   icon: PropTypes.string,
//   heading: PropTypes.string,
//   headingAlignment: PropTypes.string,
//   description: PropTypes.string,
//   descriptionAlignment: PropTypes.string,
//   hasGreenBackground: PropTypes.bool.isRequired,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// Tile.defaultProps = {
//   icon: ``,
//   heading: ``,
//   headingAlignment: `left`,
//   description: ``,
//   descriptionAlignment: `left`,
// }
